import { BASE_API_URL } from "utils/constants";
import { downloadFilePost, post } from '../../utils/api';
import { DataResponse } from "services/response";


// ================================BÁO CÁO Tài trợ quà tặng=================================================================
export interface BCTaiTroModel {
  stt: number
  profileCode: string
  profileForeignCode: string
  profileName: string
  customerGroupName: string
  personInCharge: string
  department: string
  type: string
  description: string

  value: number
  time: string
}

// ========================== BÁO CÁO TỔNG HỢP TÀI TRỢ KHÁCH HÀNG =================================================

export interface BCTHTTKHModel {
  stt: number
  profileId: string
  profileCode: string
  profileForeignCode: string
  profileName: string
  customerGroupName: string
  personInCharge: string
  department: string
  ctl: number
  gvl: number
  vp: number
  dtbk: number
  spons: number
  gift: number
  totalSpon: number
  doanhSo: number
  tiLe: number
}

// ============ Khai báo phương thức =====================

export interface IMarketingCampaignServices {
  //    lấy data báo cáo chi tiết chiến dịch Marketing
  getDataReportDSTTQTKH(data: object): Promise<DataResponse<Array<BCTaiTroModel>>>
  // export report
  exportReport(data: object): Promise<void>

  // Báo cáo tổng hợp tài trợ khách hàng
  getDataReportTHTTKH(data: object): Promise<DataResponse<Array<BCTHTTKHModel>>>
  // export excel Báo cáo tổng hợp tài trợ khách hàng
  exportTHTTKH(data: object): Promise<void>
}
// Hàm khởi tạo các phương thức của  service
export function createMarketingCampaignServices(): IMarketingCampaignServices {
  return {
    getDataReportDSTTQTKH: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-dsttqtkh`, data))
        .data;
    },

    exportReport: async (data) => {
      return (
        await downloadFilePost(
          `Reports/export-excel-dsttqtkh`, data))
    },

    // Báo cáo tổng hợp tài trợ khách hàng
    getDataReportTHTTKH: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-thttkh`, data))
        .data;
    },
    // export excel Báo cáo tổng hợp tài trợ khách hàng
    exportTHTTKH: async (data) => {
      return (
        await downloadFilePost(
          `Reports/export-excel-thttkh`, data))
    },
  };
}
